const REACT_APP_API = process.env.REACT_APP_API_URL || "";

async function fetchCollection(url) {
  const res = await fetch(url);
  const data = await res.json();
  return {
    items: data.member || [],
    view: data.view || null,
    total: data.totalItems || 0,
  };
}

function buildQueryString(filters) {
  const params = Object.entries(filters || {}).filter(([, v]) => v);
  if (params.length === 0) return "";
  return "?" + params.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
}

function withSort(filters, sort) {
  if (!sort?.key) return filters;
  return { ...filters, [`order[${sort.key}]`]: sort.dir };
}

export async function getUtilComUtc({ url, filters, sort } = {}) {
  if (url) return fetchCollection(`${REACT_APP_API}${url}`);
  return fetchCollection(`${REACT_APP_API}/api/util_com_utcs${buildQueryString(withSort(filters, sort))}`);
}

async function sendJson(method, url, body, unauthenticatedMessage, errorMessage) {
  const res = await fetch(`${REACT_APP_API}${url}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  // Une session expirée/absente renvoie une page HTML (401), pas du JSON.
  if (res.status === 401) {
    throw new Error(unauthenticatedMessage);
  }

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.message || errorMessage);
  }
  return data;
}

export async function createUser(payload) {
  return sendJson(
    "POST",
    "/api/custom/util-com-utc",
    payload,
    "Vous devez être connecté pour créer un utilisateur.",
    "Erreur lors de la création"
  );
}

export async function updateUser(utcId, patch) {
  return sendJson(
    "PATCH",
    `/api/custom/util-com-utc/${utcId}`,
    patch,
    "Vous devez être connecté pour modifier un utilisateur.",
    "Erreur lors de la mise à jour"
  );
}

async function deleteJson(url) {
  const res = await fetch(`${REACT_APP_API}${url}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (res.status === 401) {
    throw new Error("Vous devez être connecté pour supprimer un utilisateur.");
  }
  if (!res.ok) {
    const data = await res.json().catch(() => null);
    throw new Error(data?.message || "Erreur lors de la suppression");
  }
}

export async function deleteUser(utcId) {
  return deleteJson(`/api/custom/util-com-utc/${utcId}`);
}
